import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    // If it's an abort error, do not disrupt the UI
    if (
      error.name === 'AbortError' ||
      error.message?.includes('The user aborted a request') ||
      error.message?.includes('aborted')
    ) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  public override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (
      error.name !== 'AbortError' &&
      !error.message?.includes('The user aborted a request') &&
      !error.message?.includes('aborted')
    ) {
      console.error('Uncaught error:', error, errorInfo);
    }
  }

  public override render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-900 text-white flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-xl text-center">
            <h2 className="text-xl font-bold mb-2 text-rose-400">Възникна непредвидена грешка</h2>
            <p className="text-sm text-slate-400 mb-6">
              Моля, презаредете страницата, за да продължите работата си.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-slate-950 font-bold rounded-xl transition-colors cursor-pointer"
            >
              Презареди страницата
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
